import React, { useEffect, useState } from 'react';
import useEditFormScroll, { editHighlightStyle } from '../hooks/useEditFormScroll';

function StoreMaster({ token, selectedPropertyId }) {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ store_name: '', is_active: true });
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');
  const { formRef, editHighlight, scrollToForm } = useEditFormScroll();

  const resolvePropertyId = () => String(selectedPropertyId || localStorage.getItem('selectedPropertyId') || '').trim();
  const headers = (extra = {}) => ({ Authorization: `Bearer ${token}`, 'x-property-id': resolvePropertyId(), ...extra });

  useEffect(() => {
    if (!resolvePropertyId()) {
      setRows([]);
      setError('Select a property first from Hotel Config');
      return;
    }
    setError('');
    loadRows();
  }, [token, selectedPropertyId]);

  const loadRows = () => {
    if (!resolvePropertyId()) return;
    fetch('/api/store-master', { headers: headers() })
      .then(res => res.json())
      .then(data => setRows(Array.isArray(data) ? data : []))
      .catch(() => {
        setRows([]);
        setError('Failed to load stores');
      });
  };

  const handleSave = async () => {
    if (!resolvePropertyId()) return setError('Select a property first from Hotel Config');
    if (!String(form.store_name || '').trim()) return setError('Store name required');
    try {
      const res = await fetch(editingId ? `/api/store-master/${editingId}` : '/api/store-master', {
        method: editingId ? 'PUT' : 'POST',
        headers: headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) return setError(data.error || 'Save failed');
      setError('');
      setEditingId(null);
      setForm({ store_name: '', is_active: true });
      loadRows();
    } catch {
      setError('Network error');
    }
  };

  const handleDelete = async (id) => {
    if (!resolvePropertyId()) return setError('Select a property first from Hotel Config');
    try {
      const res = await fetch(`/api/store-master/${id}`, { method: 'DELETE', headers: headers() });
      const data = await res.json();
      if (!res.ok) return setError(data.error || 'Delete failed');
      setError('');
      loadRows();
    } catch {
      setError('Network error');
    }
  };

  return (
    <div className="page-shell">
      <h2 style={{ color: 'var(--theme-primary-dark)' }}>Store Master</h2>
      {error && <div className="error-banner">{error}</div>}
      <div className="filter-bar" ref={formRef} style={{ marginBottom:'2rem', ...editHighlightStyle(editHighlight) }}>
        <h3>{editingId ? 'Edit Store' : 'Add Store'}</h3>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px, 1fr))', gap:'1rem' }}>
          <input value={form.store_name} placeholder="Store Name" onChange={e => setForm({ ...form, store_name: e.target.value })} style={{ padding:'0.75rem', border:'1px solid #dcdde1', borderRadius:'6px' }} />
          <label style={{ display:'flex', alignItems:'center', gap:'0.5rem' }}>
            <input type="checkbox" checked={form.is_active} onChange={e => setForm({ ...form, is_active: e.target.checked })} />
            Active
          </label>
        </div>
        <div style={{ marginTop:'1rem', display:'flex', gap:'0.75rem' }}>
          <button onClick={handleSave} className="btn-primary" style={{ padding:'0.75rem 1.2rem', border:'none', borderRadius:'6px' }}>{editingId ? 'Update' : 'Add'}</button>
          {editingId && <button onClick={() => { setEditingId(null); setForm({ store_name: '', is_active: true }); }} className="btn-muted" style={{ padding:'0.75rem 1.2rem', border:'none', borderRadius:'6px' }}>Cancel</button>}
        </div>
      </div>

      <h3>Store List</h3>
      {rows.length === 0 ? <p>No stores found</p> : (
        <table style={{ width:'100%', borderCollapse:'collapse', background:'#fff' }}>
          <thead>
            <tr style={{ background:'var(--theme-primary-dark)', color:'#fff' }}>
              <th style={{ padding:'0.75rem', textAlign:'left' }}>ID</th>
              <th style={{ padding:'0.75rem', textAlign:'left' }}>Store Name</th>
              <th style={{ padding:'0.75rem', textAlign:'left' }}>Active</th>
              <th style={{ padding:'0.75rem', textAlign:'left' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row.id} style={{ borderBottom:'1px solid #dcdde1' }}>
                <td style={{ padding:'0.75rem' }}>{row.id}</td>
                <td style={{ padding:'0.75rem' }}>{row.store_name}</td>
                <td style={{ padding:'0.75rem' }}>{row.is_active ? 'Yes' : 'No'}</td>
                <td style={{ padding:'0.75rem', display:'flex', gap:'0.5rem' }}>
                  <button onClick={() => { setEditingId(row.id); setForm({ store_name: row.store_name || '', is_active: row.is_active !== false }); setError(''); scrollToForm(); }} className="btn-primary" style={{ border:'none', borderRadius:'4px', padding:'0.4rem 0.8rem' }}>Edit</button>
                  <button onClick={() => handleDelete(row.id)} className="btn-danger" style={{ border:'none', borderRadius:'4px', padding:'0.4rem 0.8rem' }}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default StoreMaster;
